module.exports = __webpack_public_path__ + "static/gallery_yarra_2-ae7c0a5db9f5fd65681cc2b3cbdf535a.jpg";